bcl.u.docReady(() => {
  if (bcl?.c?.header?.megaMenu) {
    bcl.c.header.megaMenu.fnOpenMenu = bcl.c.header.megaMenu.openMenu;
    bcl.c.header.megaMenu.openMenu = () => {
      window.scrollTo({ behavior: "instant", top: 0 });
      bcl.c.header.megaMenu.fnOpenMenu();
    };
  }
}, true);
